import React from 'react';
import { ClipboardCheckIcon } from 'lucide-react';
import { useReviewMode } from '../../contexts/ReviewModeContext';
interface ReviewNoteProps {
  children: React.ReactNode;
  className?: string;
}

/** Internal approval annotation. Hidden when review notes are switched off for launch. */
export function ReviewNote({
  children,
  className = ''
}: ReviewNoteProps) {
  const {
    showReviewNotes
  } = useReviewMode();
  if (!showReviewNotes) return null;
  return <aside role="note" className={`flex gap-3 border border-dashed border-review/60 bg-review/[0.06] px-4 py-3 text-sm leading-relaxed text-steel-100 ${className}`} data-id="element-508" data-mp="bl332y1isvi6">
      <ClipboardCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-review" aria-hidden="true" data-id="element-509" data-mp="1ohts0igwy8j" />
      <div data-id="element-510" data-mp="6lzxnchmon9o">
        <span className="block font-display text-[12px] font-bold uppercase tracking-[0.14em] text-review" data-id="element-511" data-mp="6pxflusgz8rz">
          For management review
        </span>
        <div className="mt-0.5" data-id="element-512" data-mp="2rf4pmmsg3815">{children}</div>
      </div>
    </aside>;
}